import { Card, FormControlLabel, Stack, Switch, Typography, useTheme } from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import { UserSwitcher } from './UserSwitcher.tsx';

interface SidebarProps {
  toggleSidebar: () => void;
  isSidebarOpen: boolean;
}

export const Sidebar = ({ toggleSidebar, isSidebarOpen }: SidebarProps) => {
  const theme = useTheme();
  const borderStyle = `1px solid ${theme.palette.grey[50]}`;
  return (
    <Stack direction="column">
      <UserSwitcher isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      {isSidebarOpen && (
        <>
          <Stack direction="row" justifyContent="center" gap={2} sx={{ py: 4, borderTop: borderStyle, borderBottom: borderStyle }}>
            <SmsOutlinedIcon />
            <ContactSupportOutlinedIcon />
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: borderStyle, px: 1 }}>
            <Typography>Help</Typography>
            <Stack direction="row">
              <TranslateOutlinedIcon />
              <FormControlLabel control={<Switch defaultChecked />} label="Italiano" labelPlacement="start" />
            </Stack>
          </Stack>
          <Stack direction="column" spacing={2} sx={{ mx: 2, mt: 2 }}>
            <Card sx={{ p: 2 }}>
              Please enter the name of your current or most recent employer. This is the organization where you are or were employed. If you are self-employed,
              please provide the name of your business. If you are a student or not currently employed, you may leave this field blank or indicate your status.
            </Card>
            <Card sx={{ p: 2 }}>
              Si prega di inserire il nome del proprio datore di lavoro attuale o più recente. Questa è l’organizzazione presso cui si è o si è stati impiegati.
              Se si è liberi professionisti, si prega di fornire il nome della propria attività. Se si è studenti o non si è attualmente impiegati, è possibile
              lasciare questo campo vuoto o indicare il proprio stato.
            </Card>
          </Stack>
        </>
      )}
    </Stack>
  );
};
